module.exports = __webpack_public_path__ + "img/close-icon.1f540717.svg";